import { ThunkAction } from "redux-thunk";
import { Store } from "Store/index";
import { ApplicationStore, SetRoutes } from "Store/application";

/**
 * Ensures that routes are registered to the Store in the correct format.
 * @TODO Implement more thorough validation.
 */
export function setRoutes(
  routes: ApplicationStore["routes"]
): ThunkAction<SetRoutes, Store, undefined, SetRoutes> {
  const validRoutes: ApplicationStore["routes"] = [];

  routes.forEach(route => {
    if (route.path[0] !== "/") route.path = `/${route.path}`;
    if (route.path.length > 1) validRoutes.push(route);
  });

  return dispatch => {
    return dispatch({ type: "APPLICATION__SET_ROUTES", routes });
  };
}
